<div class="batch-config-container">

  <div class="config-toolbar">
    <div class="toolbar-info">
      <span class="toolbar-eyebrow">
        Configuración
      </span>
      <span class="toolbar-description">
        Define los datos principales y el método de firma.
      </span>
    </div>
    <button type="button" class="help-btn" (click)="onHelp(true)" aria-label="Ayuda" title="Ver ayuda">
      <i class="fa-solid fa-circle-question"></i>
    </button>
  </div>


  <!-- ====================================================== -->
  <!-- FORMULARIO -->
  <!-- ====================================================== -->

  <form [formGroup]="batchConfigForm" data-tour="firma-step1-root" class="config-form">
    <section class="form-section">
      <div class="section-header">
        <div class="section-icon">
          <i class="fa-solid fa-file-signature"></i>
        </div>
        <div class="section-heading">
          <h3 class="section-title">
            Información general
          </h3>
          <p class="section-description">
            Define la información principal del lote de documentos.
          </p>
        </div>
      </div>


      <!-- CAMPOS -->

      <div class="row g-4">

        <!-- ================================================= -->
        <!-- TÍTULO -->
        <!-- ================================================= -->

        <div class="col-12 col-lg-4" data-tour="firma-titulo">
          <div class="field-group">
            <label for="title" class="form-label">
              Título
              <span class="required-mark">*</span>
            </label>

            <input type="text" id="title" class="form-control" formControlName="titulo"
              placeholder="Ej. Documento agosto 2026"
              [class.is-invalid]="batchConfigForm.get('titulo')?.touched && batchConfigForm.get('titulo')?.invalid" />

            <div class="field-error"
              *ngIf="batchConfigForm.get('titulo')?.touched && batchConfigForm.get('titulo')?.errors?.['required']">
              <i class="fa-solid fa-circle-exclamation"></i>
              El título es requerido.
            </div>

            <!-- MIN LENGTH -->

            <div class="field-error" *ngIf="
                batchConfigForm.get('titulo')?.touched &&
                batchConfigForm.get('titulo')?.errors?.['minlength']
              ">

              <i class="fa-solid fa-circle-exclamation"></i>

              El título debe tener al menos 3 caracteres.

            </div>

          </div>

        </div>


        <!-- ================================================= -->
        <!-- SERVICIO EXTERNO -->
        <!-- ================================================= -->

        <div class="col-12 col-lg-4">

          <div class="field-group">

            <label class="form-label">

              Servicio externo

              <span class="required-mark">*</span>

            </label>

            <ng-select formControlName="id_servicio_externo" [items]="ListExterno" bindLabel="nombre" bindValue="id"
              placeholder="Seleccione un servicio" [searchable]="true" [clearable]="true"
              (change)="$event.stopPropagation(); onServicioChange($event?.id)"

              appendTo="body"
              >
            </ng-select>


            <div class="field-error" *ngIf="
                batchConfigForm.get('id_servicio_externo')?.touched &&
                batchConfigForm.get('id_servicio_externo')?.errors?.['required']
              ">

              <i class="fa-solid fa-circle-exclamation"></i>

              El servicio externo es requerido.

            </div>

          </div>

        </div>


        <!-- ================================================= -->
        <!-- FLUJO -->
        <!-- ================================================= -->

        <div class="col-12 col-lg-4">

          <div class="field-group">

            <label class="form-label">

              Flujo

              <span class="required-mark">*</span>

            </label>


            <div class="flow-control">

              <ng-select class="flow-select" formControlName="flujo" [items]="listFlujo" bindLabel="nombre"
                bindValue="id" placeholder="Seleccione un flujo" [searchable]="true" [clearable]="true"
                (change)="onFlujoChange($event?.id)"
                appendTo="body"
                >
              </ng-select>


              <button
  type="button"
  class="flow-preview-btn"
  title="Ver flujo"
  aria-label="Ver flujo"
  (click)="buscarServicioExterno()"
  [disabled]="!batchConfigForm.get('flujo')?.value">

  <i class="fa-solid fa-eye"></i>

  <span class="flow-preview-count">
    {{ total_contrtos ?? 0 }}
  </span>

</button>

            </div>


            <div class="field-error" *ngIf="
                batchConfigForm.get('flujo')?.touched &&
                batchConfigForm.get('flujo')?.errors?.['required']
              ">

              <i class="fa-solid fa-circle-exclamation"></i>

              El flujo es requerido.

            </div>

          </div>

        </div>

      </div>

    </section>


    <!-- ==================================================== -->
    <!-- CONFIGURACIÓN DE FIRMA -->
    <!-- ==================================================== -->

    <section class="form-section" *ngIf="!plantilla_precalibrada">

      <!-- HEADER -->

      <div class="section-header">

        <div class="section-icon">
          <i class="fa-solid fa-pen-nib"></i>
        </div>

        <div class="section-heading">

          <h3 class="section-title">
            Configuración de firma
          </h3>

          <p class="section-description">
            Configura cómo se realizará la firma de los documentos.
          </p>

        </div>

      </div>


      <div class="row g-4 align-items-start">


        <!-- ================================================= -->
        <!-- FIRMA POR PLANTILLA -->
        <!-- ================================================= -->

        <div class="col-12" [class.col-lg-5]="batchConfigForm.get('firma_por_plantilla')?.value"
          [class.col-lg-12]="!batchConfigForm.get('firma_por_plantilla')?.value" data-tour="firma-por-plantilla"
          *ngIf="!batchConfigForm.get('es_grupo')?.value">

          <div class="signature-option" [class.is-enabled]="batchConfigForm.get('firma_por_plantilla')?.value">

            <div class="signature-option-left">

              <div class="signature-option-icon">

                <i class="fa-solid fa-layer-group"></i>

              </div>


              <div class="signature-option-info">

                <span class="signature-option-title">
                  Firma por plantilla
                </span>

                <span class="signature-option-description">
                  Utiliza una plantilla predefinida para configurar la firma.
                </span>

              </div>

            </div>


            <!-- SWITCH -->

            <label class="toggle-switch">

              <input id="firma_por_plantilla" type="checkbox" formControlName="firma_por_plantilla" />

              <span class="toggle-slider"></span>

            </label>

          </div>

        </div>


        <!-- ================================================= -->
        <!-- PLANTILLA -->
        <!-- ================================================= -->

        <div class="col-12 col-lg-7" *ngIf="batchConfigForm.get('firma_por_plantilla')?.value">

          <div class="field-group template-field">

            <label class="form-label">

              Plantilla

              <span class="required-mark">*</span>

            </label>

            <ng-select formControlName="id_plantilla" [items]="plantillas" bindLabel="nombre" bindValue="id"
              placeholder="Seleccione una plantilla"
              [searchable]="true"
              [clearable]="true"
              appendTo="body"
            >
            </ng-select>


            <div class="field-error" *ngIf="
                batchConfigForm.get('id_plantilla')?.touched &&
                batchConfigForm.get('id_plantilla')?.errors?.['required']
              ">

              <i class="fa-solid fa-circle-exclamation"></i>

              La plantilla es requerida.

            </div>

          </div>

        </div>

      </div>

    </section>

  </form>

</div>



<!-- ====================================================== -->
<!-- MODAL ASIGNAR SISTEMA EXTERNO -->
<!-- ====================================================== -->

<ng-template #modalAsignarExterno let-modal>

  <div class="assignment-modal">

    <!-- ================================================== -->
    <!-- HEADER -->
    <!-- ================================================== -->

    <div class="assignment-modal-header">

      <div class="assignment-modal-heading">

        <div class="assignment-modal-icon">
          <i class="fa-solid fa-file-signature"></i>
        </div>

        <div class="assignment-modal-title-group">

          <span class="assignment-modal-eyebrow">
            Sistema externo
          </span>

          <h5 class="assignment-modal-title">
            Asignar documentos
          </h5>

          <p class="assignment-modal-description">
            Confirma la cantidad de documentos que serán asignados.
          </p>

        </div>

      </div>


      <!-- CERRAR -->

      <button
        type="button"
        class="assignment-modal-close"
        aria-label="Cerrar"
        (click)="modal.dismiss('Cross click')">

        <i class="fa-solid fa-xmark"></i>

      </button>

    </div>


    <!-- ================================================== -->
    <!-- BODY -->
    <!-- ================================================== -->

    <div class="assignment-modal-body">

      <!-- RESUMEN -->

      <div class="assignment-summary">

        <div class="assignment-summary-left">

          <div class="assignment-summary-icon">
            <i class="fa-solid fa-file-contract"></i>
          </div>


          <div class="assignment-summary-info">

            <span class="assignment-summary-title">
              Documentos seleccionados
            </span>

            <span class="assignment-summary-description">
              Documentos que serán enviados al sistema externo.
            </span>

          </div>

        </div>


        <!-- CONTADOR -->

        <div class="assignment-summary-count">

          <span class="assignment-summary-number">
            {{ total_contrtos }}
          </span>

          <span class="assignment-summary-label">

            {{
              total_contrtos === 1
                ? 'Documento'
                : 'Documentos'
            }}

          </span>

        </div>

      </div>


      <!-- INFORMACIÓN -->

      <div class="assignment-info">

        <div class="assignment-info-icon">
          <i class="fa-solid fa-circle-info"></i>
        </div>

        <span>
          Verifica la cantidad de documentos antes de continuar.
        </span>

      </div>

    </div>


    <!-- ================================================== -->
    <!-- FOOTER -->
    <!-- ================================================== -->

    <div class="assignment-modal-footer">

      <button
        type="button"
        class="assignment-close-btn"
        (click)="modal.close('Cerrar click')">

        Cerrar

      </button>

    </div>

  </div>

</ng-template>